import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { Labeled, Show, ShowProps, TextField } from "react-admin";

const ChangeRequestPanel = (props: ShowProps) => (
  <Show
    {...props}
    /* disable the app title change when shown */
    title=" "
    hasEdit={false}
  >
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Change Request Detail</Typography>
      </Grid>

      <Grid item xs={4}>
        <Labeled source="Description">
          <TextField source="description" emptyText="-" />
        </Labeled>
      </Grid>
      <Grid item xs={8}></Grid>

      <Grid item xs={4}>
        <Labeled source="Cs Description">
          <TextField source="csDescription" emptyText="-" />
        </Labeled>
      </Grid>
      <Grid item xs={8}></Grid>
    </SanitizedGrid>
  </Show>
);

export default ChangeRequestPanel;
